import { capitalize } from 'lodash'
import { EDayTimeTargetDay, EDayTimeTargetTime } from '@unfoldrtech/portal-mic'
import {
  ALL_DAYS,
  ALL_TIMES,
} from '@unfoldrtech/portal-mic/dist/src/models/types'
import { sortAlphabetically } from './sort.helper'

const ALL_DAYS_AS_STRING = [...ALL_DAYS].sort(sortAlphabetically).join()
const ALL_TIMES_AS_STRING = [...ALL_TIMES].sort(sortAlphabetically).join()

export function mapTimeToFormat(time: number) {
  return `${time}:00 - ${time + 1}:00`
}

export function getCheckedDays(
  days: EDayTimeTargetDay[] | null | undefined,
  allDaysI18n: string
) {
  const allDaysSelected =
    days?.slice().sort(sortAlphabetically).join() === ALL_DAYS_AS_STRING

  if (!days || allDaysSelected) {
    return [{ value: 'all', checked: true, label: allDaysI18n }]
  }

  return days.map((day) => ({
    value: day,
    checked: !!(days && days.includes(day)),
    label: capitalize(day),
  }))
}

export function getCheckedTimes(
  times: EDayTimeTargetTime[] | null | undefined,
  allTimesI18n: string
) {
  const allTimesSelected =
    times?.slice().sort(sortAlphabetically).join() === ALL_TIMES_AS_STRING

  if (!times || allTimesSelected) {
    return [{ value: 'all', checked: true, label: allTimesI18n }]
  }

  return times.map((time) => ({
    value: time.toString(),
    checked: !!(times && times?.includes(time)),
    label: mapTimeToFormat(time),
  }))
}
